// extracted by mini-css-extract-plugin
export default {"left":"style_left__O1nlT","title":"style_title__ZEGtz","right":"style_right__c0XSY","text":"style_text__5e5IG","location-modal-content":"style_location-modal-content__Wj3Nh"};